<!-- <div>Asistencia</div> -->

<!-- <div>Próximos partidos (programación de partidos)</div> -->

<!-- @TODO -->
<!-- [class.component-dark-theme]="themeService.isDark()"
  [class.rtl-enabled]="themeService.isRTLEnabled()" -->
<mat-card
  class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"

>
  <mat-card-header>
    <mat-card-title>
      <!-- <h3 class="mb-0"> -->
      <h3>
        Partidos en curso
      </h3>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <!-- <tournaments-courts-ui
      [games]="games()"
    ></tournaments-courts-ui> -->
  </mat-card-content>
</mat-card>

<!-- @TODO -->
<!-- [class.component-dark-theme]="themeService.isDark()"
  [class.rtl-enabled]="themeService.isRTLEnabled()" -->
<!-- <mat-card
  class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"

>
  <mat-card-header>
    <mat-card-title>
      <h3 class="mb-0">
        Resumen del torneo
      </h3>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <!- <tournaments-overview-ui
      [drawings]="drawings()"
      [games]="games()"
    ></tournaments-overview-ui> ->
  </mat-card-content>
</mat-card> -->

<!-- <div class="row">
  <!- <div class="col-2">
    <app-total-orders></app-total-orders>
  </div> ->
  <div class="col-3">
    <app-sales-overview></app-sales-overview>
  </div>
</div> -->

<!-- @TODO -->
<!-- [class.component-dark-theme]="themeService.isDark()"
  [class.rtl-enabled]="themeService.isRTLEnabled()" -->
<!-- <mat-card
  class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"

> -->
  <!-- <mat-card-header style="margin-bottom: 0;">
    <mat-card-title>
      <h5 class="mb-0">
        Categorías
      </h5>
    </mat-card-title>
  </mat-card-header> -->

  <!-- <h3 style="display: inline-block;">Categorías</h3> -->

  <!-- <mat-card-content> -->
    <tournaments-categories-ui
      [tournament]="tournament()"
      [drawings]="drawings()"
      [games]="games()"
      [groupsRankings]="groupsRankings()"
      [eventsRankings]="eventsRankings()"
      [activeTab]="activeTab"
      (tabChange)="changeTab($event)"
    ></tournaments-categories-ui>
  <!-- </mat-card-content>
</mat-card> -->
